export const SCENE_KEYS = {
  boot: 'boot-scene',
  preload: 'preload-scene',
  gameplay: 'gameplay-scene',
} as const;

export const TEXTURE_KEYS = {
  particle: 'fx-particle',
  glow: 'fx-glow',
} as const;

export const ASSET_KEYS = {
  ottoCharacter: 'character-otto',
  ottoFace: 'character-otto-face',
} as const;

export const EVENT_KEYS = {
  touchTap: 'input:touch-tap',
  touchDragStart: 'input:touch-drag-start',
  touchDrag: 'input:touch-drag',
  touchDragEnd: 'input:touch-drag-end',
  touchChange: 'input:touch-change',
} as const;
